import script from "./shareFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./shareFolder.vue?vue&type=script&setup=true&lang=js"

import "./shareFolder.vue?vue&type=style&index=0&id=0ef15337&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef15337"]])

export default __exports__